import intervalUntilExists from "./intervalUntilExists";
/**
 * Calls handler once resolved
 * @param {string} selector
 * @param {function} handler
 */
const onContentChangeArray = (selector: any, handler: any, pageDocument: Document | ShadowRoot = document) => {
  intervalUntilExists(selector, () => {
    let oldContentSelectors = pageDocument.querySelectorAll(selector);
    let oldContent = "";

    oldContentSelectors.forEach((item: any) => {
      oldContent += item.textContent.trim();
    });
    setInterval(function () {
      let currentContentSelectors = pageDocument.querySelectorAll(selector);
      let currentContent = "";

      currentContentSelectors.forEach((item: any) => {
        currentContent += item.textContent.trim();
      });

      if (oldContent.replace(/\s/g, "") !== currentContent.replace(/\s/g, "")) {
        oldContent = currentContent;
        handler();
      } else {
      }
    }, 500);
  },
  undefined,
  pageDocument
)};

export default onContentChangeArray;
